import { useEffect, useRef, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { IoSearchOutline, IoCloseOutline } from "react-icons/io5";

export default function SearchSection({ handleSearchBar, navigate, setActiveTab, activeTab, SearchItem, handleSearchfun }) {
    const buttonRowRef = useRef(null);
    const customScrollbarRef = useRef(null);
    const customThumbRef = useRef(null);
    const [isCustomDragging, setIsCustomDragging] = useState(false);
    const [customStartX, setCustomStartX] = useState(0);
    const [showShopPopup, setShowPathPopup] = useState(false);

    // Sync custom scrollbar thumb with button row scroll
    useEffect(() => {
        const buttonRow = buttonRowRef.current;
        const thumb = customThumbRef.current;
        const scrollbar = customScrollbarRef.current;
        if (!buttonRow || !thumb || !scrollbar) return;

        const updateThumb = () => {
            const scrollWidth = buttonRow.scrollWidth;
            const clientWidth = buttonRow.clientWidth;
            const scrollLeft = buttonRow.scrollLeft;
            const scrollbarWidth = scrollbar.offsetWidth;
            const thumbWidth = Math.max((clientWidth / scrollWidth) * scrollbarWidth, 30); // min width
            thumb.style.width = `${thumbWidth}px`;
            const maxScroll = scrollWidth - clientWidth;
            const maxThumbMove = scrollbarWidth - thumbWidth;
            const thumbLeft = maxScroll > 0 ? (scrollLeft / maxScroll) * maxThumbMove : 0;
            thumb.style.transform = `translateX(${thumbLeft}px)`;
        };

        buttonRow.addEventListener('scroll', updateThumb);
        window.addEventListener('resize', updateThumb);
        updateThumb();
        return () => {
            buttonRow.removeEventListener('scroll', updateThumb);
            window.removeEventListener('resize', updateThumb);
        };
    }, []);

    // Dragging the custom scrollbar thumb
    useEffect(() => {
        if (!isCustomDragging) return;
        const buttonRow = buttonRowRef.current;
        const thumb = customThumbRef.current;
        const scrollbar = customScrollbarRef.current;
        if (!buttonRow || !thumb || !scrollbar) return;

        const onMouseMove = (e) => {
            const scrollbarRect = scrollbar.getBoundingClientRect();
            const thumbWidth = thumb.offsetWidth;
            let newX = e.clientX - scrollbarRect.left - customStartX;
            const maxThumbMove = scrollbar.offsetWidth - thumbWidth;
            newX = Math.max(0, Math.min(newX, maxThumbMove));
            const scrollWidth = buttonRow.scrollWidth;
            const clientWidth = buttonRow.clientWidth;
            const maxScroll = scrollWidth - clientWidth;
            const scrollLeft = maxScroll > 0 ? (newX / maxThumbMove) * maxScroll : 0;
            buttonRow.scrollLeft = scrollLeft;
        };
        const onMouseUp = () => setIsCustomDragging(false);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, [isCustomDragging, customStartX]);

    const handleCustomThumbDown = (e) => {
        setIsCustomDragging(true);
        setCustomStartX(e.clientX - customThumbRef.current.getBoundingClientRect().left);
        e.preventDefault();
    };

    const handleNavigate = (data) => {
        switch (data) {
            case "Groups":
            case "Trending":
            case "Hashtags":
            case "Users":
            case "Posts":
            case "All":
                if (activeTab === data) {
                    setActiveTab("All");
                } else {
                    setActiveTab(data);
                }
                break;
            default:
                break;
        }
    };

    const handleClearSearch = () => {
        handleSearchBar({ target: { value: "" } });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchfun();
        }
    };

    return (
        <>
            <div className="sticky top-0 z-10 bg-white dark:bg-[#1E1D21] pb-0.5">
                <div className="w-full flex justify-between items-center pt-2 px-1 gap-x-2">
                    <IoMdArrowBack
                        onClick={() => { navigate("/"); setActiveTab("All"); }}
                        className="text-[25px] cursor-pointer text-black dark:text-white"
                    />
                    <div className="relative w-full">
                        <input
                            value={SearchItem}
                            placeholder="Search"
                            onChange={handleSearchBar}
                            onKeyDown={handleKeyDown}
                            className="w-full pl-8 pr-2 py-2 outline-none text-[14px] font-semibold text-black placeholder:text-[#5C5C5C] bg-[#ECE5FF] dark:bg-[#333333] dark:text-white dark:placeholder:text-[#AAAAAA] rounded-full"
                        />
                        <IoSearchOutline
                            className="absolute left-2 top-[10px] text-[#5C5C5C] dark:text-white text-[18px]"
                        />
                    </div>
                </div>
                <div className="overflow-hidden m-2">
                    <div
                        ref={buttonRowRef}
                        style={{ scrollbarHeight: 8 }}
                        className="flex w-full items-center overflow-x-scroll gap-x-2 show-scrollbar custom-x-scrollbar"
                    >
                        {["All", "Users", "Posts", "Trending", "Hashtags"].map((data) => (
                            <div key={data}>
                                <button
                                    onClick={() => handleNavigate(data)}
                                    className={`text-xs font-semibold rounded-full w-20 py-1.5 ${activeTab === data ? "bg-[#5C5C5C] dark:bg-[#BDE6FF] text-white dark:text-black hover:bg-gray-900 dark:hover:bg-[#BDE6FF]"
                                        : "bg-[#BDE6FF] text-black dark:bg-[#333333] dark:text-white"} whitespace-nowrap transition-colors`}
                                >
                                    {data}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {showShopPopup &&
                <div className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[90%] h-[15vh] flex flex-col items-center justify-center">
                        <p className="text-[16px] font-semibold text-black whitespace-nowrap">Chaa Chingg's Shop</p>
                        <p className="text-[16px] font-semibold text-black whitespace-nowrap">will be available soon</p>
                        <button
                            onClick={() => setShowPathPopup(!showShopPopup)}
                            className="bg-white text-red-500 px-7 py-1 border border-gray-400 rounded-full mt-2 hover:bg-gray-100 transition-colors duration-300"
                        >
                            Close
                        </button>
                    </div>
                </div>}
        </>
    );
}